export default __webpack_public_path__ + "static/media/DOM-MAY2026.211a88ab.png";